import { useQuery } from "@tanstack/react-query";

import { IOneMstsTest } from "../../../@types/admin/AdminOneMsts";
import { oneMstsService } from "../../../services/admin";
import { ensureOk } from "../../../utils/ensureOk";

/** Every 1MSTS test — the page's list query. */
export function useOneMstsTests() {
  const { data, isLoading, isError } = useQuery<IOneMstsTest[]>({
    queryKey: ["admin-one-msts-tests"],
    queryFn: async () => ensureOk(await oneMstsService.getOneMstsTests()),
    // No manual Refresh button on migrated admin pages (EN-5129 UI feedback),
    // and the global QueryClient disables refetch-on-mount with a 3-minute
    // staleTime — so re-opening the page must re-read the list.
    refetchOnMount: "always",
  });

  return { oneMstsTests: data ?? [], isLoading, isError };
}
